import { Box, Button, Grid, Paper, Typography, styled } from "@mui/material";
import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getCookie } from "../../../Cookies";
import "../../styles/Training/Training.css";
import "../../Translater/Translater";
import Navbar from "../Navbar/Navbar";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../Firebase";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function InternalTrainingMain() {
  const navigate = useNavigate();
  const goToHome = () => navigate("/");

  const fetch_user_courses = httpsCallable(functions, "fetch_user_courses");


  /////======= fetch user courses
  const [user_courses, setUserCourses] = useState([]);
  useEffect(() => {
    fetch_user_courses({select:1})
      .then((res) => {
        // console.log(res.data);
        setUserCourses([...res.data]);
      })
      .catch((err) => {
        console.log(err);
      });
    }, []);

  // useEffect(() => {
  //   if (getCookie("UID") == null || getCookie("ROLE") != "user") {
  //     goToHome();
  //     return <></>;
  //   }
  // });
  const { t } = useTranslation();

  return (
    <div>
      <Navbar page={t("training")} />
      <Box sx={{ flexGrow: 1, mt: 10 }}>
        <Container>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {
              //////we have to map the courses to the grid
              user_courses.map((course, index) => {
               return(

            <Grid key={index} item xs={2} sm={4} md={4}>
              <Item
                sx={{
                  boxShadow:
                    "4px 4px 10px rgba(0, 118, 135, 0.05), 6px 6px 40px rgba(0, 118, 135, 0.1)",
                  borderRadius: "10px",
                  m: "none",
                  background: "#fff",
                  borderRadius: "10px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    position: "absolute",
                    right: 0,
                    top: 0,
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ fontSize: "8px", color: "#F18040" }}>
                    Internal Training
                  </Typography>
                  <Box
                    sx={{
                      width: "20px",
                      height: "20px",
                      backgroundColor: "#F18040",
                      ml: 1,
                    }}
                  ></Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "12px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background:
                        "linear-gradient(90deg, #007848 0%, #004577 105.46%);",
                    }}
                  >
                    <svg
                      width="35"
                      height="34"
                      viewBox="0 0 35 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.4822 15.9106H17.327C19.5859 15.9109 21.845 15.9111 24.1041 15.9112C25.0807 15.911 25.5321 15.4625 25.5321 14.4841C25.5333 10.1291 25.5333 5.774 25.5321 1.41893C25.5318 0.462116 25.0727 0.000678594 24.1247 0.000678594C19.5841 -0.000226198 15.0435 -0.000226198 10.503 0.000678594C9.57716 0.000859553 9.10713 0.470171 9.10713 1.39813C9.10556 5.77575 9.10556 10.1533 9.10713 14.5307C9.1075 15.4401 9.57879 15.9106 10.4822 15.9106ZM15.6207 3.44929C15.9031 2.54622 16.3368 2.23597 17.3161 2.19724C17.4079 2.21735 17.5003 2.23541 17.5928 2.25348C17.7982 2.29362 18.0037 2.33377 18.2018 2.39629C18.5671 2.51292 18.7977 2.76907 18.9154 3.14727C19.8237 6.04961 20.7325 8.95182 21.6419 11.8539C21.8018 12.364 21.6937 12.6939 21.2081 12.9087C20.8701 13.0576 20.5089 13.147 20.1404 13.1729C19.6968 13.2017 19.5173 13.0186 19.3965 12.5889C19.3636 12.4719 19.3302 12.3549 19.2969 12.238C19.1914 11.8676 19.0857 11.497 18.9932 11.1231C18.9486 10.943 18.8654 10.894 18.6901 10.8954C17.7753 10.9036 16.8604 10.9036 15.9455 10.8954C15.7641 10.8937 15.6917 10.9548 15.6482 11.1299C15.5519 11.5165 15.4425 11.9001 15.3332 12.2837L15.3332 12.2838C15.3035 12.3877 15.2739 12.4917 15.2445 12.5957C15.1261 13.0148 14.9312 13.213 14.4948 13.1721C14.0948 13.1333 13.7047 13.0245 13.3425 12.8505C12.9462 12.6585 12.8599 12.3036 12.9951 11.8693C13.8692 9.06226 14.7444 6.2556 15.6207 3.44929ZM33.2186 33.9963C33.9525 33.9988 34.4572 33.7412 34.7155 33.0457V18.8233C34.4143 18.1366 33.887 17.9219 33.1471 17.9258C29.7873 17.9436 26.4274 17.9414 23.0674 17.9392H23.0665C21.9526 17.9385 20.8387 17.9378 19.7248 17.9378C18.7332 17.9378 18.3008 18.3686 18.3008 19.3583C18.3007 20.5553 18.3019 21.7523 18.3031 22.9493V22.95V22.9501V22.9501V22.9501C18.3062 26.143 18.3094 29.3358 18.2882 32.5285C18.2815 33.5513 18.9364 34.0035 19.7626 33.9993C24.248 33.9819 28.7333 33.9809 33.2186 33.9963ZM22.7769 26.7519V26.7519V26.7519V26.7519V26.7518C22.7793 26.5105 22.7817 26.2692 22.7817 26.028C22.7814 25.8022 22.78 25.5764 22.7785 25.3506C22.7751 24.8204 22.7717 24.2902 22.7833 23.7603C22.8214 22.0546 23.8071 20.9163 25.4964 20.6489C26.7193 20.4554 27.9081 20.5513 28.9886 21.2314C29.8939 21.8012 30.2877 22.6385 30.2345 23.6942C30.205 24.2778 29.966 24.5468 29.3849 24.5834C29.0489 24.6014 28.712 24.5779 28.3818 24.5135C28.063 24.4535 27.8842 24.2208 27.867 23.8853C27.8024 22.608 26.8442 22.4619 26.0101 22.6519C25.4999 22.768 25.1724 23.1897 25.1641 23.7849C25.1432 25.2848 25.1394 26.7855 25.1653 28.2852C25.1772 28.9738 25.5976 29.3882 26.2422 29.466C27.0144 29.5593 27.5043 29.2815 27.7314 28.6085C27.7894 28.4262 27.8332 28.2397 27.8624 28.0507C27.9309 27.653 28.1057 27.4324 28.5026 27.3704C28.8023 27.3224 29.107 27.3137 29.4089 27.3444C29.9989 27.4084 30.2111 27.6574 30.2359 28.2546C30.2853 29.4456 29.8131 30.3751 28.7601 30.9418C27.41 31.6686 25.9906 31.7151 24.5775 31.1459C23.3439 30.6491 22.8372 29.6311 22.7874 28.3624C22.7663 27.8264 22.7716 27.2892 22.7769 26.7519ZM8.13651 17.9373H14.9167C15.8048 17.9373 16.2715 18.4057 16.2717 19.2969C16.2725 23.7329 16.2725 28.1689 16.2717 32.6049C16.2717 33.512 15.8006 33.9874 14.8975 33.9876C10.3887 33.989 5.87992 33.989 1.37112 33.9876C0.468387 33.9876 0.000452904 33.5122 0.000362323 32.6033C-0.000120774 28.1673 -0.000120774 23.7313 0.000362323 19.2953C0.000362323 18.403 0.464681 17.9381 1.35618 17.9381C3.61647 17.9366 5.87658 17.9364 8.13651 17.9373ZM4.40241 25.9949C4.40241 27.518 4.40256 29.041 4.40286 30.5642C4.40341 31.1335 4.64815 31.41 5.21237 31.4147L5.63162 31.4186C6.79071 31.4295 7.95042 31.4405 9.10853 31.4068C10.5278 31.3654 11.518 30.589 11.749 29.287C11.8667 28.6206 11.8522 27.9167 11.7943 27.2388C11.7637 26.8834 11.5564 26.5149 11.3461 26.2096C11.0161 25.7296 10.9657 25.2807 11.222 24.7552C11.3938 24.4266 11.5087 24.0714 11.5618 23.7045C11.7335 22.1294 11.2365 20.8053 9.30545 20.6303C8.20963 20.5309 7.1018 20.5536 5.99561 20.5762H5.99559H5.99556H5.99554L5.99526 20.5763L5.99497 20.5763L5.99468 20.5763C5.67639 20.5828 5.35823 20.5893 5.04054 20.5929C4.61817 20.5976 4.40476 20.8995 4.40386 21.3579C4.4009 22.9038 4.40044 24.4494 4.4025 25.9949H4.40241ZM17.2798 5.25549L16.2104 9.08937L18.4167 9.08955L17.3458 5.25323L17.2798 5.25549ZM6.78711 26.4461C6.96775 26.4461 7.14607 26.4432 7.32263 26.4403H7.32269C7.72161 26.4337 8.11157 26.4274 8.49909 26.4551C9.0452 26.494 9.36087 26.7742 9.43297 27.3147C9.48797 27.7483 9.48041 28.1876 9.41051 28.6191C9.33751 29.0778 8.99067 29.3497 8.53088 29.3773C8.13312 29.4014 7.7336 29.396 7.32617 29.3905H7.32604C7.14814 29.3881 6.96873 29.3857 6.78729 29.3857L6.78711 26.4461ZM7.30112 22.5873C7.13373 22.5888 6.9643 22.5903 6.79199 22.5903V24.6475H7.15496C7.28194 24.6472 7.40897 24.6482 7.53599 24.6493C7.82661 24.6516 8.1172 24.654 8.40714 24.641C8.90171 24.6189 9.22201 24.2035 9.22138 23.6205C9.22074 23.0391 8.90198 22.6147 8.41221 22.5951C8.04579 22.5805 7.67863 22.5838 7.30112 22.5873Z"
                        fill="white"
                      />
                    </svg>
                  </Box>
                  <Box sx={{ textAlign: "left", ml: "15px" }}>
                    <Typography
                      sx={{
                        color: "#007C84",
                        fontSize: "12px",
                        fontWeight: 600,
                      }}
                    >
                      {course.courseName}
                    </Typography>
                    <Typography sx={{ color: "#007C84", fontSize: "12px" }}>
                      Description about the courses
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    mt: 1,
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        width: "100px",
                        height: "5px",
                        border: "1px solid #007C84",
                        display: "flex",
                        alignItems: "center",
                        m: "5px 0px",
                      }}
                    >
                      <Box
                        sx={{
                          width: "90%",
                          height: "100%",
                          background: "#007C84",
                          ml: "1 px",
                        }}
                      ></Box>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: "#007C84",
                        textAlign: "left",
                      }}
                    >
                      90% Completed
                    </Typography>
                  </Box>
                  
                  <Button
                    sx={{
                      textTransform: "none",
                      color: "#fff",
                      padding: "5px 30px",
                      background: "linear-gradient(to right, #007848, #004577)",
                      borderRadius: "15px",
                      fontWeight: 600,
                      width: "90px",
                      fontSize: "12px",
                    }}
                  >
                    Continue
                  </Button>
                </Box>
              </Item>
            </Grid>
               )})

            }
          </Grid>
        </Container>
      </Box>
    </div>
  );
}

export default InternalTrainingMain;
